import { Reducer } from 'react';

export interface StepState {
  currentStepIndex: number;
}

export type StepAction = { type: 'NEXT_STEP' } | { type: 'PREVIOUS_STEP' } | { type: 'RESET' };

export const initialStepState: StepState = {
  currentStepIndex: 0,
};

export const createStepReducer = (stepCount: number): Reducer<StepState, StepAction> => {
  const maxIndex = Math.max(stepCount - 1, 0);
  return (state, action) => {
    switch (action.type) {
      case 'NEXT_STEP':
        return {
          ...state,
          currentStepIndex: Math.min(state.currentStepIndex + 1, maxIndex),
        };
      case 'PREVIOUS_STEP':
        return {
          ...state,
          currentStepIndex: Math.max(state.currentStepIndex - 1, 0),
        };
      case 'RESET':
        return initialStepState;
      default:
        return state;
    }
  };
};
